module.exports = ".home.wrapper {\n  padding-top: 10px;\n  background-color: white; }\n  .home.wrapper .breadcrumb {\n    background: #cccccc;\n    color: #333333; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.scss
// module id = ./src/app/components/home/home.component.scss
// module chunks = main